// General
const STAGE_CONFIGS = {
  LOCAL: {
    BASE_URL: 'http://localhost:3000/local',
    IDENTITY_POOL_ID: 'us-east-1:7b38a457-148f-4fd8-ab87-7298dbc3602a',
    USER_POOL_ID: 'us-east-1_yorLwqsre',
    USER_POOL_WEB_CLIENT_ID: '4n9hudqa25fq6euejpq90kd4ot',
  },
  DEVELOP: {
    BASE_URL: 'https://lc3hliy7u4.execute-api.us-east-1.amazonaws.com/develop',
    IDENTITY_POOL_ID: 'us-east-1:7b38a457-148f-4fd8-ab87-7298dbc3602a',
    USER_POOL_ID: 'us-east-1_yorLwqsre',
    USER_POOL_WEB_CLIENT_ID: '4n9hudqa25fq6euejpq90kd4ot',
  },
  PROD: {
    BASE_URL: 'https://3vnml889tk.execute-api.us-east-1.amazonaws.com/prod',
    IDENTITY_POOL_ID: 'us-east-1:7ccecd03-df91-4a5f-9076-d6c5f5152dc5',
    USER_POOL_ID: 'us-east-1_dlKJ8TvG9',
    USER_POOL_WEB_CLIENT_ID: '21agl6k2c5icoo6bnv3jtab06n',
  },
};

if (!Object.keys(STAGE_CONFIGS).includes(process.env.REACT_APP_STAGE))
  throw new Error(`STAGE ${process.env.REACT_APP_STAGE} IS NOT VALID`);
export const STAGE = process.env.REACT_APP_STAGE;

export const LESSON = 'LESSON';
export const APP_READING = 'READING';
export const APP_WORD_WORK = 'WORD_WORK';
export const APP_WORD_SORT = 'WORD_SORT';
export const APP_WORD_DIVISION = 'WORD_DIVISION';
export const APP_WRITING = 'WRITING';
export const APP_ASSESSMENT = 'ASSESSMENT';
export const APP_TITLES = {
  [APP_READING]: 'Reading',
  [APP_WORD_WORK]: 'Word Work',
  [APP_WORD_SORT]: 'Word Sort',
  [APP_WORD_DIVISION]: 'Word Division',
  [APP_WRITING]: 'Writing for Reading',
  [APP_ASSESSMENT]: 'Assessments',
};
export const FEATURES = {
  SESSION: 'SESSION',
  STUDENT: 'STUDENT',
  LESSON: 'LESSON',
  EXERCISE_READING: 'EXERCISE_READING',
  EXERCISE_WORD_WORK: 'EXERCISE_WORD_WORK',
  EXERCISE_WORD_SORT: 'EXERCISE_WORD_SORT',
  EXERCISE_WORD_DIVISION: 'EXERCISE_WORD_DIVISION',
  EXERCISE_ASSESSMENT: 'EXERCISE_ASSESSMENT',
  EXERCISE_WRITING: 'EXERCISE_WRITING',
  VISIBILITY_PRIVATE: 'VISIBILITY_PRIVATE',
  VISIBILITY_USER_GROUP: 'VISIBILITY_USER_GROUP',
  VISIBILITY_PUBLIC: 'VISIBILITY_PUBLIC',
};
export const SNACKBAR_DURATION = 3000;

// Lesson step status
export const PENDING = 'PENDING';
export const IN_PROGRESS = 'IN_PROGRESS';
export const COMPLETE = 'COMPLETE';

// Reading exercises that are added to a lesson can have a goal
export const READING_EXERCISE_GOAL_FLUENCY = 'READING_FLUENCY';
export const READING_EXERCISE_GOAL_MEANING = 'READING_MEANING';
export const READING_EXERCISE_GOAL_ASSESSMENT = 'READING_ASSESSMENT';
export const READING_EXERCISE_GOALS_DISPLAY_NAME = {
  [READING_EXERCISE_GOAL_FLUENCY]: 'Reading for Fluency',
  [READING_EXERCISE_GOAL_MEANING]: 'Reading for Meaning',
  [READING_EXERCISE_GOAL_ASSESSMENT]: 'Reading for Assessment',
};

export const MAX_UPLOAD_FILE_SIZE = 50000000; // 50MB
export const MIME_TYPE = {
  PDF: 'application/pdf',
  PNG: 'image/png',
  JPG: 'image/jpeg',
  GIF: 'image/gif',
};
export const UPLOAD_TYPE = {
  EXERCISE_READING: 'EXERCISE_READING',
  EXERCISE_ASSESSMENT: 'EXERCISE_ASSESSMENT',
  USER_AVATAR: 'USER_AVATAR',
};

// AWS API Gateway
export const ENDPOINT = 'ufli-api';
export const AWS_REGION = 'us-east-1';
export const BASE_URL = STAGE_CONFIGS[STAGE].BASE_URL;

// AWS Cognito
export const PASSWORD_MIN_LENGTH = 8;
export const CONFIRMATION_CODE_LENGTH = 6;
export const AUTH_CONFIG = {
  region: AWS_REGION,
  identityPoolId: STAGE_CONFIGS[STAGE].IDENTITY_POOL_ID,
  userPoolId: STAGE_CONFIGS[STAGE].USER_POOL_ID,
  userPoolWebClientId: STAGE_CONFIGS[STAGE].USER_POOL_WEB_CLIENT_ID,
};
